package one.healthium.pcos.presentation.navigation.home.compose

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.adaptive.currentWindowAdaptiveInfo
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import com.arkivanov.decompose.extensions.compose.stack.Children
import com.arkivanov.decompose.extensions.compose.stack.animation.fade
import com.arkivanov.decompose.extensions.compose.stack.animation.stackAnimation
import one.healthium.content.navigation.content.ContentContent
import one.healthium.content.navigation.insights.InsightsContent
import one.healthium.content.navigation.main.MainContentContent
import one.healthium.content.navigation.shopping_list.ShoppingListContent
import one.healthium.pcos.presentation.navigation.home.HomeComponent
import one.healthium.pcos.presentation.navigation.today.TodayContent
import one.healthium.profile.navigation.ProfileMainContent
import one.healthium.tasks.navigation.DailyTasksContent
import one.healthium.today.ui.pcos.TodayScreen
import one.healthium.ui.common.utils.isMedium
import one.healthium.ui.compose.components.adaptive.TwoPaneLayout

@Composable
internal fun AdaptiveHomeContent(component: HomeComponent) {
    val windowSizeClass = currentWindowAdaptiveInfo().windowSizeClass

    LaunchedEffect(component, windowSizeClass) {
        component.isCompactMode = !windowSizeClass.isMedium()
    }

    if (windowSizeClass.isMedium()) {
        MediumHomeContent(component)
    } else {
        CompactHomeContent(component)
    }
}

@Composable
private fun CompactHomeContent(component: HomeComponent) {
    Column(Modifier.fillMaxSize()) {
        Children(
            modifier = Modifier.weight(1f),
            component = component
        )
        BottomNavigation(component)
    }
}

@Composable
private fun MediumHomeContent(component: HomeComponent) {
    Row {
        NavigationRail(component)
        TwoPaneLayout(
            primaryPane = {
                TodayScreen(component)
            },
            secondaryPane = {
                Children(
                    modifier = Modifier.fillMaxSize(),
                    component = component,
                    skipToday = true,
                )
            }
        )
    }
}

@Composable
private fun Children(
    modifier: Modifier = Modifier,
    component: HomeComponent,
    skipToday: Boolean = false,
) {
    Children(
        modifier = modifier,
        stack = component.stack,
        animation = stackAnimation(fade())
    ) {
        when (val child = it.instance) {
            is HomeComponent.Child.TodayChild -> if (skipToday.not()) TodayContent(child.component) else Unit
            is HomeComponent.Child.DailyTasksChild -> DailyTasksContent(child.component)
            is HomeComponent.Child.InsightsChild -> InsightsContent(child.component)
            is HomeComponent.Child.MainContentChild -> MainContentContent(child.component)
            is HomeComponent.Child.ChatChild -> Unit
            is HomeComponent.Child.ProfileChild -> ProfileMainContent(child.component)
            is HomeComponent.Child.Content -> ContentContent(child.component)
            is HomeComponent.Child.ShoppingList -> ShoppingListContent(child.component)
        }
    }
}
